import { findErrorsInModel } from '../utils/validation/findErrorsInModel';
import { postCode as postCodeValidation, dateMoved } from '../constants/validation/addressDetails';
import { isBFPOPostcode } from '../utils/isBFPOPostcode';

function getSchema() {
  return {
    AddressInput: (postCode) =>
      (postCode === '' && postCode) || (isBFPOPostcode(postCode) && postCodeValidation),
    MOVE_IN_DATE: (moveInDate) => moveInDate === '' && dateMoved
  };
}

export const validateModel = (model) => {
  const schema = getSchema();
  const foundErrors = findErrorsInModel(model, schema);

  return foundErrors;
};

export const validateFormField = (field, value) => {
  const schema = getSchema();
  return schema[field] && schema[field](value);
};
